module.exports = __webpack_public_path__ + "static/media/timeline_front.ede83e2c.svg";